export default [
  {
    key: "increasement",
    sortable: true,
    sortField: "createdAt",
    label: "label.no",
    thClass: "w-50px",
  },
  {
    key: "title",
    // sortable: true,
    // sortField: "firstName",
    label: "field.holidayTitle",
    // stickyColumn: true,
    // variant: "light",
  },
  {
    key: "type",
    label: "field.type",
  },
  {
    key: "date",
    label: "field.date",
  },
  {
    key: "description",
    label: "field.description",
  },
  {
    key: "createdAt",
    sortable: true,
    sortField: "createdAt",
    label: "field.createDate",
  },
  {
    key: "actions",
    label: "general.action",
  },
];
